/* Dansk katalog for locale-reports-labels-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'rep.zeroHidden': 'Kontiene har nulsaldo i perioden. Vis dem via filtre.',
  'rep.showZero': 'Vis konti med nulsaldo',
  'rep.group.tax': 'SKATTEOMKOSTNING',
  'rep.trial.titleHelp': 'Saldobalancen viser alle konti i kontoplanen med saldo for den valgte periode. Tryk på en kontolinje for at se de bilag, der er bogført på kontoen.',
  'rep.trial.viewHelp': 'Saldobalancen viser som standard kun aktive konti — konti med saldo eller bevægelse. »Vis også inaktive konti« medtager resten af kontoplanen, og »Vis kun konti med bevægelse« kræver, at kontoen er bogført i perioden. Vis som vælger, om beløbene vises i kroner og øre, hele kroner eller hele tusinder.',
  'rep.trial.empty': 'Ingen bogførte saldi for den valgte periode.',
  'rep.trial.oneSupplier': '1 leverandør',
  'rep.trial.supplierCount': '{n} leverandører',
  'rep.trial.oneCustomer': '1 kunde',
  'rep.trial.customerCount': '{n} kunder',
  'rep.trial.oneOpenCustomerItem': '1 åben post',
  'rep.trial.openCustomerItems': '{n} åbne poster',
  'rep.trial.customerDifference': 'Andre posteringer / afstemningsdifference',
  'rep.trial.noCustomerBalances': 'Ingen kundesaldi i den valgte visning.',
  'rep.trial.oneOpenSupplierItem': '1 åben post',
  'rep.trial.openSupplierItems': '{n} åbne poster',
  'rep.trial.supplierDifference': 'Andre posteringer / afstemningsdifference',
  'rep.trial.noSupplierBalances': 'Ingen leverandørsaldi i den valgte visning.',
  'rep.trial.exportTitle': 'Saldobalance: {column}',
  'rep.group.assets': 'AKTIVER',
  'rep.group.equityLiabilities': 'EGENKAPITAL / GÆLD',
  'rep.group.operatingIncome': 'DRIFTSINDTÆGTER',
  'rep.group.operatingCosts': 'DRIFTSOMKOSTNINGER',
  'rep.groupTotal': 'Sum {group}',
  'rep.balance.opening': 'Primo',
  'rep.balance.movement': 'Ændring',
  'rep.balance.closing': 'Ultimo',
  'rep.showAs.withDecimals': 'Kroner og øre',
  'rep.showAs.whole': 'Hele kroner',
  'rep.showAs.thousands': 'Hele tusinder',
  'rep.result.titleHelp': 'Resultatopgørelsen viser indtægterne og omkostningerne i perioden, og hvad der bliver tilbage som resultat. Åbn en sektion for at se kontiene bag tallene, og tryk på en kontolinje for at se de bilag, der er bogført der.',
  'rep.result.subtitle': 'Start med opsummeringen, og åbn kontodetaljer efter behov.',
  'rep.result.income': 'Driftsindtægter',
  'rep.result.costs': 'Driftsomkostninger',
  'rep.result.finance': 'Finansielle poster',
  'rep.result.beforeTax': 'Resultat før skat',
  'rep.result.noLines': 'Ingen aktivitet på disse konti endnu.',
  'rep.total': 'Sum',
  'rep.showDetails': 'Vis detaljer',
  'rep.hideDetails': 'Skjul detaljer',
  'rep.shareOfLargest': '{pct} % af største post',
  'rep.showVouchersFor': 'Vis alle bilag på {account}',
  'rep.period.otherYear': 'Viser tal for regnskabsåret {year}.',
  'rep.period.singleYear': 'Perioden strækker sig over to regnskabsår. Rapporten beregnes pr. regnskabsår med åbningsbalance fra årets start, så vælg en periode inden for ét år.',
  'rep.export.busy': 'Eksporterer...',
  'rep.export.downloaded': '{format} downloadet',
  'rep.export.failed': 'Kunne ikke eksportere rapporten.',
  'rep.export.pdfUnavailable': 'Rapport-PDF er ikke koblet til backend.',
  'rep.export.year': 'År',
  'rep.export.period': 'Periode',
  'rep.export.summary': 'Opsummering',
  'rep.export.item': 'Post',
  'rep.export.amount': 'Beløb',
  'rep.accountHelp.receivables': 'Tilgodehavender fra kunder er penge, kunder skylder dig for fakturaer, der ikke er betalt endnu.',
  'rep.accountHelp.bank': 'Bankindestående viser penge på driftskontoen.',
  'rep.accountHelp.payables': 'Leverandørgæld er fakturaer og køb, du skylder leverandører.',
  'rep.accountHelp.outputVat': 'Udgående moms er merværdiafgift, du har opkrævet ved salg.',
  'rep.accountHelp.inputVat': 'Indgående moms er merværdiafgift, du har betalt ved køb og normalt kan få fradrag for.',
  'rep.accountHelp.vatSettlement': 'Momsafregningskonto viser nettomoms, du skylder eller har til gode.',
  'rep.accountHelp.vatableSales': 'Momspligtig salgsindtægt viser almindeligt salg, hvor der beregnes udgående moms.',
  'rep.accountHelp.group.asset': 'Aktivkonto: værdier, virksomheden ejer eller har til gode.',
  'rep.accountHelp.group.equityLiability': 'Egenkapital eller gæld: finansiering, skyldige beløb og afregningsposter.',
  'rep.accountHelp.group.income': 'Indtægtskonto: salg og andre indtægter i virksomheden.',
  'rep.accountHelp.group.goods': 'Vareforbrug: omkostninger knyttet til varer, råvarer eller videresalg.',
  'rep.accountHelp.group.payroll': 'Lønomkostning: løn, feriepenge og personalerelaterede ydelser.',
  'rep.accountHelp.group.operating': 'Driftsomkostning: omkostninger ved at drive virksomheden.',
  'rep.accountHelp.group.finance': 'Finans- eller skattekonto: renter, finansielle poster eller skatteomkostning.',
  'rep.accountHelp.other': 'Konto {account} i kontoplanen.',
  'rep.accountHelp.openVouchers': 'Tryk på kontolinjen for at se alle bilag, der er bogført på denne konto.',
  'rep.dimensions.title': 'Projekt og afdeling',
  'rep.dimensions.help': 'Filtrér rapporten uden at ændre kildedata. Hele bilaget bevares, inklusive modposterne.',
  'rep.dimensions.project': 'Projekt',
  'rep.dimensions.department': 'Afdeling',
  'rep.dimensions.all': 'Alle',
  'rep.dimensions.unassigned': 'Ikke fordelt',
  'rep.incompleteBasisTitle': 'Regnskabsgrundlaget er ufuldstændigt',
  'rep.incompleteBasisText': 'Rapporten vises ikke som komplet, fordi journaldækningen eller det nødvendige åbningsgrundlag ikke er dokumenteret. Tilgængelige data er bevaret til kontrol.',
  'rep.importedBasisTitle': 'Importeret regnskabsstatistik.',
  'rep.importedBasisText': 'Tallene kommer fra kontrolleret importeret kontostatistik, ikke journalhændelser i Plumme. De er ikke certificerede og kan ikke bruges til indsendelse, betalingsgodkendelse eller årsafslutning.',
  'rep.importedBasisExport': 'Kontrolleret importeret kontostatistik; ikke journalkomplet eller certificeret.',
});
